import { useLocalSearchParams } from 'expo-router'

import FosterAdoptionCard from '@/components/fosters/cards/FosterAdoptionsCard'
import { useFosterFormContext } from '@/components/fosters/FosterFormContext'
import FosterTab from '@/components/fosters/FosterTab'
import useFosterOwner from '@/hooks/useFosterOwner'
import { useAppStore } from '@/store/useAppStore'

const FosterAdoptionsTab = () => {
  const { id: fosterId } = useLocalSearchParams<{ id: string }>()
  const { control } = useFosterFormContext()
  const isFosterOwner = useFosterOwner(fosterId)

  const currentOrganization = useAppStore.use.currentOrganization().organization
  const isDisabled = !currentOrganization?.subscriptionActive || !isFosterOwner

  return (
    <FosterTab fosterId={fosterId} viewId="foster-adoptions-tab">
      <FosterAdoptionCard
        control={control}
        disabled={isDisabled}
        fosterId={fosterId}
      />
    </FosterTab>
  )
}

export default FosterAdoptionsTab
